import { Tab } from '@hologram-dimension/tab';
import clsx from 'clsx/lite';
import { BorderlessPanel } from 'components';
import sharedPageStyles from 'pages/sharedPage.module.css';
import { type FC } from 'react';
import useOrganization from 'state/contexts/Organization/useOrganization';
import useOrgUrl from 'utils/legacy/useOrgUrl';
import UsagePredeploymentActivationHistory from 'views/UsageReports/UsagePredeploymentActivationHistory/UsagePredeploymentActivationHistory';
import UsagePredeploymentAgeAnalysis from 'views/UsageReports/UsagePredeploymentAgeAnalysis/UsagePredeploymentAgeAnalysis';
import UsagePredeploymentTesting from 'views/UsageReports/UsagePredeploymentTesting/UsagePredeploymentTesting';
import useUserInfo from 'hooks/User/useUserInfo';
import ReleaseFlag from 'api/legacy/releaseFlags/enumReleaseFlags';
import styles from './PredeploymentTesting.module.css';

const views = {
  intesting: 'SIMs in testing',
  exitedtesting: 'Activation history',
  testinginventory: 'Pre-deployment age analysis',
};

export type PredeploymentReportViews = keyof typeof views | null;

interface PredeploymentTestingProps {
  className?: string;
  viewKey: PredeploymentReportViews;
  handleTabClick: (url: string) => void;
  usageBaseUrl: string;
}

const PredeploymentTesting: FC<PredeploymentTestingProps> = ({
  className,
  handleTabClick,
  usageBaseUrl,
  viewKey,
}) => {
  const orgId = useOrganization();
  const url = useOrgUrl({ baseUrl: usageBaseUrl, orgId });

  const { releaseFlags } = useUserInfo();

  const hasPreflightOverview = releaseFlags?.has(ReleaseFlag.EMBED_PREFLIGHT_OVERVIEW);

  return (
    <div className={clsx(sharedPageStyles.pageWrapper, styles.wrapper, className)}>
      <BorderlessPanel
        headerContents={<div className={styles.headerContents}>Pre-deployment SIMs</div>}
        headerClassName={styles.header}
        contentsClassName={styles.contents}
        tabs={
          <div className={clsx(sharedPageStyles.tabWrapper, styles.tabWrapper)}>
            {Object.keys(views).map(
              (view) =>
                (view !== 'testinginventory' || hasPreflightOverview) && (
                  <Tab
                    key={view}
                    selected={view === viewKey}
                    onClick={() => handleTabClick(`${url}/${view}`)}
                  >
                    {views[view as NonNullable<PredeploymentReportViews>]}
                  </Tab>
                )
            )}
          </div>
        }
      >
        <div className={sharedPageStyles.viewsWrapperNoPadding}>
          {viewKey === 'intesting' && <UsagePredeploymentTesting />}
          {viewKey === 'exitedtesting' && <UsagePredeploymentActivationHistory />}
          {viewKey === 'testinginventory' && <UsagePredeploymentAgeAnalysis />}
        </div>
      </BorderlessPanel>
    </div>
  );
};
export default PredeploymentTesting;
